import React from "react"
import clsx from "utils/clsx"

export type BadgeProps = React.ComponentProps<"div"> & {
  /**
   * Whether to show the badge or not
   */
  showBadge?: boolean
  /**
   * The component to be used for the badge
   */
  badgeComponent?: React.ReactNode
  className?: string
}
const Badge = ({
  children,
  showBadge = true,
  badgeComponent,
  className,
  ...props
}: BadgeProps) => {
  return (
    <div className={clsx("vt-badge", className)} {...props}>
      {children}
      {showBadge && badgeComponent}
    </div>
  )
}

export default Badge
